import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchGetCodeTableDetails = (data) => ({
  type: actionTypes.GET_CODETABLE_DATA,
  rebateCodeSerchResult: data,
});

export const setTabValue = (value) => ({
  type: actionTypes.SET_TAB_VALUE,
  payload: value,
});

export const dispatchErrorMessages = (messages) => ({
  type: actionTypes.SET_ERROR_MESSAGES,
  payload: messages,
});

export const getCodeTableDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CODETABLE_DATA, values)
    .then((response) => {
      dispatch(dispatchGetCodeTableDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchGetCodeTableDetails({ error: 'API failed' }));
    });
};

export const updateCodeTableDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_CODETABLE_DATA, values)
    .then((response) => {
      if (response.status === '200') {
        dispatch(getCodeTableDetails());
      }
    })
    .catch((error) => {
      dispatch(dispatchGetCodeTableDetails(error.response.data));
    });
};
export const setReduxDataIntoSearchScr = (payload) => {
  return {
    type: actionTypes.SET_REDUX_DATA_SEARCH_SCREEN,
    payload,
  };
};
export const dispatchContactDetails = (data) => ({
  type: actionTypes.GET_CONTACT_DETAILS,
  contactDetails: data,
});

export const setClientSearchDataAction = (payload) => {
  return {
    type: actionTypes.CLIENT_SEARCH_DATA_ACTION_TYPES,
    payload,
  };
};

export const getContactDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DETAILS, values)
    .then((response) => {
      dispatch(dispatchContactDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchContactDetails({ error: 'API failed' }));
    });
};

export const dispatchClientDetails = (data) => ({
  type: actionTypes.GET_CLIENT_DETAILS,
  clientDetails: data,
});

export const getClientDetails = (clientId) => (dispatch) => {
  axios
    .post(serviceEndPoint.GET_CLIENT_DETAILS, { clientId: clientId })
    .then((response) => {
      const data = response?.data?.data;
      dispatch(dispatchClientDetails(data));
    })
    .catch((error) => {
      dispatch(dispatchClientDetails({ error: 'API failed' }));
    });
};

export const clearReduxForMaintainClientScreen = (payload) => {
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

  if (
    (payload === '/client' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/maintain';
      }).length > 0) ||
    (payload === '/maintain' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/client';
      }).length > 0)
  ) {
    return {
      type: actionTypes?.SET_CLEAR_REDUX_DATA_CLINT,
    };
  }
  return null;
};
